export const hasDataChanged = <T extends Record<string, any>>(updatedData: T, originalData: Partial<T> | undefined): boolean => {
    let hasChange = false;
    for (const [key, value] of Object.entries(updatedData)) {
        if (value != null && value !== originalData?.[key as keyof T]) {
            hasChange = true;
            break;
        }
    }
    return hasChange;
};
